import React, { forwardRef, useState } from "react";
import {noop, isEmpty, capitalize} from 'lodash';
import { checkCharLimit, FieldTypes, finiteNumberRegexValidator } from "utils/formUtils";
import BaseModalForm from "components/BaseModalForm";
import { FINDING_STATUS_DISPLAY_TEXT, FINDING_STATUS } from "views/Findings/Constants";

export default forwardRef(function ReleasePopup({type = "delete", afterClose, promptMessage, onOk = noop, ...restProps}, ref) {
    const [acceptRisk, setAcceptRisk] = useState(false)
    const baseModalProps = {
        ...restProps.modalProps,
        title: restProps.title || "Are you sure?",
        okText: restProps.okText || capitalize(type),
        okButtonProps: { type: "primary", danger: !isEmpty(type) },
        className: type + "-popup",
    }

    const fields = [
    {
        name: "acceptRisk",
        label: <span className="m-r-xs">{FINDING_STATUS_DISPLAY_TEXT[FINDING_STATUS.ACCEPT_RISK]}</span>,
        type: FieldTypes.SWITCH,
        className: "inline-form-item",
        props: {
          onChange: setAcceptRisk,
        }
    },
    ...acceptRisk ? [{
      name: "days",
      label: 'Unsuppress After',
      help: "This will accept risk until the given time and hold the release post time given.",
      placeholder: 'Days',
      type: FieldTypes.NUMBER,
      required: true,
      min: 0,
      labelCol: { span: 8 },
      wrapperCol: { span: 6 },
      className: "inline-form-item",
      rules: [finiteNumberRegexValidator()],
      props: {
        suffix: 'Days'
      }
    }] : [],
    {
        name: 'note',
        label: 'Note',
        type: FieldTypes.TEXT_AREA,
        NoDefaultLengthRule: true,
        rules: [{
            required: true,
            message: "A note is required",
            whitespace: true
        }, () => checkCharLimit(255) ],
    }
    ]

    return (
        <BaseModalForm
            ref={ref}
            {...baseModalProps}
            fields={fields}
            initialValues={{days: 7}}
            afterClose={afterClose}
            onOk={onOk}
         />
    )
})